import { render, staticRenderFns } from "./pi-table.vue?vue&type=template&id=367c01b8&scoped=true&"
import script from "./pi-table.vue?vue&type=script&lang=ts&"
export * from "./pi-table.vue?vue&type=script&lang=ts&"
import style0 from "./pi-table.vue?vue&type=style&index=0&id=367c01b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367c01b8",
  null
  
)

export default component.exports